import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MailTemplatesService {
  private apiUrl = environment.apiURL + 'mail-templates';

  constructor(private http: HttpClient) {}

  getTemplates(pageNumber: number = 1, pageSize: number = 25, params: any = {}): Observable<any> {
    return this.http.get(this.apiUrl, {
      params: { page: pageNumber.toString(), pageSize: pageSize.toString(), ...params },
    });
  }

  getAvailableTemplates(pageNumber: number = 1, pageSize: number = 25): Observable<any> {
    return this.http.get(`${this.apiUrl}/available`, {
      params: { page: pageNumber.toString(), pageSize: pageSize.toString() },
    });
  }

  getTemplate(reference: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${reference}`);
  }

  createTemplate(body: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/new`, body);
  }

  updateTemplate(reference: string, body: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${reference}/update`, body);
  }

  deleteTemplate(reference: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${reference}/delete`);
  }

  uploadLogo(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.apiUrl}/logo`, formData);
  }
}
